export default {
  translations: {
    commons: {
      alt: {
        agroPicture: 'AGROBRAZIL'
      },
      states: {
        acre: 'Acre',
        amapa: 'Amapá',
        amazonas: 'Amazonas',
        roraima: 'Roraima',
        rondonia: 'Rondônia',
        para: 'Pará',
        tocantins: 'Tocantins',
        alagoas: 'Alagoas',
        bahia: 'Bahia',
        ceara: 'Ceará',
        maranhao: 'Maranhão',
        piaui: 'Piauí',
        paraiba: 'Paraíba',
        pernanbuco: 'Pernanbuco',
        rioGrandeDoNorte: 'Rio Grande do Norte',
        sergipe: 'Sergipe',
        espiritoSanto: 'Espírito Santo',
        minasGerais: 'Minas Gerais',
        rioDeJaneiro: 'Rio de Janeiro',
        saoPaulo: 'São Paulo',
        parana: 'Paraná',
        santaCatarina: 'Santa Catarina',
        rioGrandeDoSul: 'Rio Grande do Sul',
        distritoFederal: 'Distrito Federal',
        goias: 'Goiás',
        matoGrosso: 'Mato Grosso',
        matoGrossodoSul: 'Mato Grosso do Sul',
        paraguai: 'Paraguai'
      },
      regions: {
        regiaoNorte: 'Região Norte',
        regiaoNordeste: 'Região Nordeste',
        regiaoSudeste: 'Região Sudeste',
        regiaoSul: 'Região Sul',
        regiaoCentroOeste: 'Região Centro-Oeste',
      },
      dateTime: {
        hour: 'hora',
        hours: 'horas',
        day: 'dia',
        days: 'dias',
        aDayAgo: 'um dia atrás',
        month: 'mês',
        months: 'meses',
        aMonth: 'um mês',
        year: 'ano',
        years: 'anos',
        ago: 'atrás',
        an: 'menos de uma',
      },
      buttons: {
        next: 'PRÓXIMA',
        previous: 'ANTERIOR'
      },
      messages: {
        deleteConfirmation: 'Deseja Realmente EXCLUIR?'
      }
    },

    pages: {
      announcement: {
        newAd: 'NOVO ANÚNCIO',
        back: 'VOLTAR',
        adTitle: 'Título do anuncio',
        adMsg: 'Escreva sua mensagem para o anúncio',
        adDuration: 'Quantidade dias de duração do anuncio',
        biweekly: '15 Dias',
        mounth: '30 Dias',
        categories: 'Categorias',
        hasVideo: 'Esse produto possui vídeo?',
        phone: 'Telefone',
        city: 'Cidade',
        breed: 'Raça',
        heads: 'Quatidade de Cabeças',
        ageMounth: 'Idade dos animais em meses',
        weight: 'Peso aproximado em quilo',
        price: 'Valor',
        fifteenKilos: 'Arroba',
        sacs: 'Saca',
        tons: 'Tonelada',
        head: 'Cabeças',
        liveKilos: 'Quilo/Vivo',
        observation: 'Observação',
        success: 'DADOS ENVIADOS COM SUCESSO!',
        error: 'DADOS INCORRETOS!',
        send: 'ENVIAR',
        placeholders: {
          tags: 'Selecione uma Tag',
        }
      },

      announcementDetails: {
        breed: 'Raça: ',
        age: 'Idade: ',
        weightKG: 'Peso dos animais em KG: ',
        heads: 'Quantidade de cabeças: ',
        price: 'Valor: ',
        observation: 'Obs: ',
        back: 'VOLTAR',
        fifteenKilos: 'Arroba',
        sacs: 'Saca',
        tons: 'Tonelada',
        head: 'Cabeça',
        liveKilos: 'Quilo/Vivo',
        messages: {
          errors: {
            insertAPicture: 'Envie uma foto',
          }
        },
        placeholders: {
          tags: 'Selecione uma Tag',
        }
      },

      classifieds: {
        edit: 'Editar',
        delete: 'Excluir',
        wantDelete: 'Deseja Realmente EXCLUIR?',
        title: 'TIMELINE / CLASSIFICADOS',
        previous: 'ANTERIOR',
        next: 'PRÓXIMA',
        more: 'CONTINUAR LENDO',
      },

      paymentData:  { 
        paymentBy: ' Pagamento por ',
        placeholder: {
          state: 'Estado',
          city: 'Cidade',
          CEP: 'CEP',
          street: 'Rua.Av',
          number: 'Numero',
          complement: 'Complemento'
        },
        next: 'PROXIMO',
      },

      scales: {
        more: 'CONTINUAR LENDO',
        previous: 'ANTERIOR',
        next: 'PRÓXIMA',
      },
      
      scalesDetails: {
        back: 'VOLTAR'
      },
    
      includes: {
        filters: {
          all: 'TODOS',
          classified: 'CLASSIFICADOS',
        },

        footer: {
          copyright: 'AGROBRAZIL © 2020 - Todos os direitos reservados'
        },

        header: {
          welcome: 'Bem Vindo!',
          profile: 'Perfil',
          ranking: 'Ranking',
          timeline: 'Timeline',
          scales: 'Escalas',
          negotiations: 'Negociações',
          options: {
            newMessage: 'Escrever nova mensagem',
            newNegotiation: 'Cadastrar negócio',
            newClassified: 'Criar anúncio',
          }
        },

        navNegotiations: {
          negotiations: 'NEGOCIAÇÕES',
          sendReceive: 'ENVIADAS E RECEBIDAS'
        },

        navProfile: {
          profile: 'PERFIL',
          publications: 'PUBLICAÇÕES',
          myAdverts: 'MEUS ANÚNCIOS',
        },

        profileMenu: {
          informations: 'Editar Informações',
          interests: 'Editar Interesses',
          password: 'Alterar Senha',
          updatePlan: 'Atualizar Plano',
          cancelPlan: 'Cancelar Plano',
          about: 'Sobre',
          logoff: 'Sair da Conta',
          cacelMesssage: 'Seu cancelamento foi solicitado, será processado em até 5 dias!',
        }

      },

      logon: {
        info: 'Informação produtiva direto no celular',
        mobileInfo: 'Informação produtiva direto no celular! Para melhor desempenho você será redirecionado para o APP de sua Loja.',
        errorLogin: 'Falha no login!',
        placeholder: {
          password: 'Senha',
          email: 'Email'
        },
        buttons: {
          register: 'CRIAR CONTA',
          login: 'ENTRAR',
          forgetPassword: 'Esqueci minha Senha'
        }
      },

      logonSite: {
        errorLogin: 'Falha no login!'
      },

      message: {
        alerts: {
          tags: 'Possivel selecionar o máximo de 7 TAGS!',
        },
        title: 'NOVA MENSAGEM',
        labels: {
          tags: 'Tags',
          text: 'Mensagem'
        },
        select: {
          tags: 'Selecione as tags'
        },
        placeholders: {
          searchTag: 'Buscar tag',
          text: 'Escreva a mensagem'
        },
        buttons: {
          publish: 'PUBLICAR',
          back: 'VOLTAR'
        }
      },

      myAnnouncements : {
        previous: 'ANTERIOR',
        next: 'PRÓXIMA',
        alert: {
          confirmDelete:  'Deseja Realmente EXCLUIR?',
        },
        edit: 'Editar',
        delete: 'Excluir',
        title: 'MEUS ANÚNCIOS',
        more: 'CONTINUAR LENDO'
      },

      changeMyAnnouncements: {
        erros: {
          sendPhoto: 'Envie uma foto'
        },
        placeholder: {
          city: 'Cidade'
        },
        selectTag: 'Selecione uma Tag',
        title: 'ALTERAR ANÚNCIO',
        announcementTitle: 'Título do anuncio',
        message: 'Escreva sua mensagem para o anúncio',
        duration: 'Quantidade dias de duração do anuncio',
        biweekly: '15 dias',
        mounth: '30 dias',
        categories: 'Categorias',
        hasVideo: 'Esse produto possui vídeo?',
        telephone: 'Telefone',
        breed: 'Raça',
        numberHeads: 'Quatidade de Cabeças',
        ageMounth: 'Idade dos animais em meses',
        weightKG: 'Peso aproximado em quilo',
        price: 'Valor',
        fifteenKilos: 'Arroba',
        sacs: 'Saca',
        tons: 'Tonelada',
        heads: 'Cabeças',
        liveKilos: 'Quilo/Vivo',
        observation: 'OBS',
        success: 'DADOS ENVIADOS COM SUCESSO!',
        error: 'DADOS INCORRETOS!',
        send: 'ENVIAR',
        back: 'VOLTAR',
      },

      business: {
        title: 'CADASTRAR NEGOCIO',
        soldBought: 'Vendeu ou Comprou?',
        sold: 'Vendeu',
        bought: 'Comprou',
        negociationDate: 'Data de Negociação',
        deliveryDate: 'Data de Entrega',
        negociated: 'O que negociou?',
        selectTag: 'Selecione uma Tag',
        slaughterPlant: 'Planta de Abate',
        authorize: 'Autorizo a publicação do frigorífico?',
        yes: 'Sim',
        no: 'Não',
        slaughterWay: 'Forma de abate',
        deadWeight: 'Peso Morto',
        liveWeight: 'Peso Vivo',
        hasFasting: 'Existe Jejum?',
        fastingHours: 'Quantas horas de Jejum?',
        values: 'Valores',
        fifteenKilos: 'R$/arroba',
        sacs: 'Saca',
        tons: 'Tonelada',
        head: 'Cabeças',
        awards: 'Premiações',
        breedPattern: 'Padrão racial do lote',
        type: 'Tipo',
        castratedAnimals: 'Animais Castrados',
        wholeAnimals: 'Animais Inteiros',
        termination: 'Terminação',
        semiConfined: 'Semi-confinado',
        confined: 'Confinado',
        protein: 'A parto + proteina',
        pasture: 'Pasto',
        paymentType: 'Forma de pagamento',
        inCash: 'À vista',
        inInstallment: 'À prazo',
        tax: 'Imposto',
        toCharge: 'Pagamento sobre a folha 20%',
        free: 'À descontar 1,5% na comercialização',
        taxFree: 'Livre de impostos',
        delivery: 'Frete por conta do',
        buyer: 'Comprador - FOB',
        seller: 'Vendedor - CIF',
        city: 'Cidade',
        slaughterReport: 'Informar abates',
        slaughterAnimals: 'Quantidade de animais abatidos',
        slaughterDateLabel: 'Data de abate',
        addSlaughter: 'Adicionar Abate',
        slaughterItem: 'Abate: ',
        animalsQtyLabel: 'Qtde de animais: ',
        newSlaughterDate: 'Adicionar novo dia',
        sendTo: 'Enviar para',
        success: 'DADOS ENVIADOS COM SUCESSO!',
        sending: 'Enviando informações…',
        send: 'Enviar',
        sendLoading: 'Enviando…',
        back: 'VOLTAR',
        errors: {
          incorrectData: 'DADOS INCORRETOS!',
          selectTag: 'Uma tag deve ser selecionada',
          invalidPercent: 'A porcentagem não esta correta',
        },
        placeholder: {
          price: 'Valor negociado',
          others: 'Outros valores',
          weight: 'Peso do bovino (Kg)',
          animalsAmount: 'Quantidade de animais',
          amount: 'Quantidade',
          slaughterDate: 'Data Inicial',
          observation: 'Observações',
          select: 'Selecione...',
          noOptions: 'Nenhuma opção'
        },
        options: {
          measureTypes: {
            fifteen_kilos: 'arroba',
            sacs: 'Saca',
            tons: 'Tonelada',
            head: 'Cabeças'
          },
          cattleBreeds: {
            nelore: 'Nelore',
            angus: 'Angus',
            other_breeds: 'Demais cruzamentsos',
            no_breed: 'Sem raça definida'
          },
        }
      },

      recover: {
        info: 'Informação produtiva direto no celular',
        emailInfo: 'Informe o seu email para que possamos enviar as intruções de recuperação de senha',
        placeholder: {
          email: 'Email'
        },
        buttons: {
          send: 'ENVIAR',
          backToLogin: 'Voltar para o Login'
        },
        alert: {
          sendPassword: {
            success: 'Foi enviado um e-mail com instruções de troca de senha!'
          }
        }
      },

      register: {
        header: 'Cadastro',
        subheader: 'Faça o seu cadastro e teste por 30 dias!',
        toLogin: 'Voltar ao Login',
        placeholder: {
          fullname: 'Nome Completo*',
          nickname: 'Apelido*',
          email: 'Email*',
          cellphone: 'Telefone Celular*',
          cpf: 'CPF*',
          password: 'Senha*',
          passwordConfirm: 'Confirmar a Senha*',
        },
        inputs: {
          meet: 'Como conheceu a Agrobrazil',
          indication: 'Indicação',
          acceptedNews: 'Aceito receber novidades sobre o mercado.',
          terms: 'Concordo com os <span className="lkTermo" onClick={termos}>Termos de Uso e Política de Privacidade</spanEnd>'
        },
        buttons: {
          confirm: 'CADASTRAR'
        },
        errors: {
          invalid: 'DADOS INCORRETOS!',
          fullname: '- Preencha o nome Completo',
          nickname: '- Preencha o Apelido',
          email: '- Preencha o E-mail',
          invalidEmail: '- Email Inválido!',
          cellphone: '- Preencha o Telefone Celular',
          invalidCellphone: '- Telefone Celular Inválido',
          cpf: '- Preencha o CPF!',
          invalidCpf: '- CPF Inválido',
          password: '- Preencha a Senha',
          matchPassword: '- Senha e confirmação da senha não conferem!',
          terms: '- Concorde com os termos de Uso e política de privacidade!',
        },
        success: 'CADASTRO REALIZADO COM SUCESSO!'
      },

      about: {
        title: 'SOBRE',
        whoAreWe: {
          title: 'Quem somos?',
          infoOne: 'A AGROBRAZIL é resultado da união no setor da agropecuária. pecuaristas, tecnologia e outros integrantes da comunidade estão juntos para realizar algo único. Uma plataforma que filtra, analiza e organiza informações do mercado de compra e venda do boi gordo em tempo real e diariamente, tais como:',
          listItemOne: 'Negócios realizados',
          listItemTwo: 'Preço e escala frigorífica',
          listItemThree: 'Dados do mercado futuru',
          listItemFour: 'Informações atuais sobre o mercado e muito mais!',
          infoTwo: 'A sua tomada de decisão como empresário e pecuarista nunca será a mesma. Através do aplicativo, você pode planejar estrategicamente e garantir que o aumento do seu lucro.'
        },
        howItWorks: {
          title: 'Como funciona?',
          infoOne: 'Para que fosse possível trazer notícias imediatas à maior quantidade de cliente ao mesmo tempo, desenvolvemos nosso próprio aplicativo onde são postados e discutidos assuntos pertinentes ao mercado do Boi Gordo.',
          infoTwo: 'A captação de negócios é feita de duas formas: Por cliente Premium que enviam seus negócios realizados de forma sigilosa e segura através do nosso aplicativo e também de nosso captador.',
          infoThree: 'Preços e escalas frigoríficas também são o diferencial AGROBRAZIL. Informações advindas de várias fonte, processadas de forma automática são cruzadas para que assim possamos averiguar e trazer total transparência, agilidade e segurança.',
          infoFour: 'A parceria com a Cross Investimentos, umas das maiores e mais respeitadas corretoras de BM&F nos traz notícias e fechamentos relevantes ao mercado deixando você ainda mais informado.'
        },
      },

      timeline: {
        download: 'BAIXAR ARQUIVOS',
        bestNegotiation: 'Melhor negócio do dia',
        validatedOnBlockChain: 'VALIDADO NA BLOCKCHAIN',
        keepReading: 'CONTINUAR LENDO',
        title: {
          withoutHashTag: 'TIMELINE / TODOS',
          withHashTag: 'TIMELINE / #',
          withSearch: 'TIMELINE / BUSCA: '
        },
        alt: {
          profile: 'Perfil',
          blockchain: 'blockchain'
        },
        view_more: ' VER MAIS',
        only_for_premium: 'Imagem disponível para Premium'
      },

      timelineSearch: {
        keepReading: 'CONTINUAR LENDO',
        buttons: {
          apply: 'APLICAR FILTROS',
          close: 'FECHAR FILTRO',
          loading: 'CARREGANDO...'
        },
        select: {
          states: 'Selecione o Estado',
          tags: 'Selecione as tags'
        },
        labels: {
          dateInit: 'Data Inicial: ',
          dateEnd: 'Data Final: ',
          filter: 'Filtro: ',
          results: 'Resultados do filtro: ',
          loading: 'Carregando resultados…',
          tags: 'Tags: ',
          state: 'Estado: '
        },
        placeholders: {
          searchTag: 'Buscar tag'
        },
        alt: {
          profile: 'Perfil'
        }
      },

      timelineDetails: {
        download: 'BAIXAR ARQUIVOS',
        keepReading: 'CONTINUAR LENDO',
        buttons: {
          delete: 'Excluir',
          edit: 'Editar',
          back: 'VOLTAR'
        },
        labels: {
          dateInit: 'Data Inicial: ',
        },
        placeholders: {
          message: 'Escreva um comentário'
        }
      },

      withoutPermission: {
        title: 'Sem permissão para o conteúdo solicidado, faça upgrade do seu plano',
        subTitle: 'Meu Plano',
        buttons: {
          updatePlan: 'ATUALIZAR PLANO'
        }
      },

      rankingDetails: {
        overalAverage: 'Média geral:',
        maleAverage: 'Machos: Média',
        femaleAverage: 'Fêmeas: Média',
        avaliations: 'Avaliações',
        avaliation: 'avaliações',
        buttons: {
          goBack: 'VOLTAR'
        }
      },

      ranking: {
        title: 'Ranking de Frigorificos',
        name: 'Frigorifico',
        note: 'Nota',
        alt: {
          up: 'Desceu',
          down: 'Subiu',
          keep: 'Manteve'
        },
        sortDesc: 'Maior nota primeiro',
        sortAsc: 'Menor nota primeiro'
      },

      publications: {
        title: 'PUBLICAÇÕES',
        buttons: {
          edit: 'Editar',
          delete: 'Excluir'
        },
        alt: {
          profile: 'Perfil'
        }
      },

      publicationEdit: {
        title: 'EDITAR PUBLICAÇÃO',
        messages: {
          maxOfTags: 'MÁXIMO DE TAGS PERMITIDO: 7!'
        }
      },

      listPlans: {
        title: 'Planos'
      },

      profileInterests: {
        title: 'MEUS INTERESSES',
        buttons: {
          update: 'ATUALIZAR'
        },
        labels: {
          tags: 'Tags'
        },
        select: {
          tags: 'Selecione as tags'
        },
        placeholders: {
          searchTag: 'Buscar tag'
        },
        messages: {
          interestsUpdated: 'SEUS INTERESSE FORAM ALTERADOS!',
          maxOfTags: 'MÁXIMO DE TAGS PERMITIDA: 7!'
        }
      },

      profileEditPassword: {
        title: 'ALTERAR SENHA',
        buttons: {
          update: 'ALTERAR SENHA'
        },
        labels: {
          currentPassword: 'Senha Atual*',
          newPassword: 'Nova Senha*',
          confirmationNewPassword: 'Repitir nova senha*'
        },
        messages: {
          passwordMinLength: 'Senha deve ter mais de 6 digitos!',
          passwordConfirmationMinLength: 'Confirmação da Senha deve ter mais de 6 digitos!',
          diferentPasswords: 'A senha e confirmação estão diferentes!'
        }
      },

      profileEdit: {
        title: 'EDITAR PERFIL',
        buttons: {
          update: 'SALVAR ALTERAÇÃO'
        },
        labels: {
          name: 'Nome completo*',
          nickname: 'Apelido*',
          email: 'Email',
          phone: 'Telefone Celular (DD) XXXXX-XXXX',
          picture: 'Enviar nova foto',
          chooseFile: 'Escolher arquivo'
        },
        messages: {
          fillName: 'Preencha o nome completo!',
          fillNickname: 'Apelido tem que ter mais que 5 letras!',
          sucefullEdited: 'DADOS ALTERADOS COM SUCESSSO!'
        },
        alt: {
          withoutPicture: 'SEM FOTO'
        }
      },

      profile: {
        title: 'PERFIL',
        myPlan: 'Meu Plano',
        interests: 'Interesses acompanhados',
        allowNotifications: 'Aceito receber novidades sobre o mercado',
        allowNegotiationsOfOthersUsers: 'Permitir que outros usuários enviem negociações',
        buttons: {
          updatePlan: 'ATUALIZAR PLANO',
          cancelPlan: 'CANCELAR PLANO'
        },
        labels: {
          name: 'Nome completo*',
          nickname: 'Apelido*',
          email: 'Email',
          phone: 'Telefone Celular (DD) XXXXX-XXXX',
          picture: 'Enviar nova foto'
        },
        messages: {
          fillName: 'Preencha o nome completo!',
          fillNickname: 'Apelido tem que ter mais que 5 letras!',
          sucefullEdited: 'DADOS ALTERADOS COM SUCESSSO!'
        },
        alt: {
          withoutPicture: 'SEM FOTO'
        }
      },

      paymentMethod: {
        title: 'Pagamento',
        monthly: 'Mensal',
        payForms: {
          credCard: 'Cartão de Crédito'
        }
      },

      paymentCard: {
        title: 'Pagamento Cartão',
        processing: 'Aguarde.... Processando Pagamento',
        paymentFor: 'Pagamento por',
        alt: {
          payForms: 'Visa, Master, Diners. Amex'
        },
        placeholders: {
          cardNumber: 'Número do Cartão',
          cardCVV: 'CVV',
          cardHolder: 'Titular do Cartão',
          cardDate: 'MM/AA'
        },
        alerts: {
          changingPlan: 'Estamos Trocando seu Plano..',
          changedPlan: 'Plano Alterado',
          redirecting: 'Estamos te redirecionando  para a Tela de Agradecimento',
          sendingConfirmationData: 'Mandando Dados pra confirmaçao',
          buySuccess: 'Compra Aprovada Com Sucesso!!',
          buyFail: 'Compra Nao Aprovada',
          verifyUserData: 'Por Favor verifique se todos os Campos Foram Preenchidos Corretamente',
          confirmingData: 'Dados Sendo Confirmados'
        },
        buttons: {
          buttonLoader: {
            pay: 'Pagar'
          }
        }
      },

      paymentTicket: {
        title: 'Obrigado',
        subtitle: 'Transação realizada com sucesso - O boleto esta disponível para download no botão abaixo. As novas funcionalidades estarão disponíveis apos a compensação bancária',
        buttons: {
          printTicket: 'Imprimir Boleto'
        },
        alerts: {
          success: 'Compra Aprovada Com Sucesso!!',
          fail: 'Your Credit Card is Invalid'
        }
      },

      thanks: {
        title: 'Obrigado',
        info: 'Transação realizada com sucesso -  As novas funcionalidades já estão disponíveis para uso.'
      },

      notifications: {
        title: 'NOTIFICAÇÕES',
        date: 'Data da Notificação:',
        notification: 'Notificação:'
      },

      negotiationInformation: {
        title: 'ALTERAR INFORMAÇÃO DA NEGOCIAÇÃO',
        loading: 'carregando ....',
        slaughter: 'Abate: ',
        slaughterDate: 'Data de Abate: ',
        animalsQuantity: 'Qtde de animais: ',
        sendTo: 'Enviar Para',
        info: 'pInit Agora no app Agrobrazil você pode compartilhar o PDF de uma negociação fora do aplicativo. pEnd pInit Você também pode enviar a negociação para o usuário da Agrobrazil o qual negociou pEnd pInit Após ser aprovada por ele, um novo PDF de negocição poderá ser gerado contendo os dados do comprador e vendedor pEnd',
        messages: {
          success: 'DADOS ENVIADOS COM SUCESSO!',
          invalidData: 'DADOS INCORRETOS!'
        },
        buttons: {
          send: 'FINALIZAR E COMPARTILHAR'
        }
      },

      negotiationDetails: {
        title: 'ALTERAR NEGOCIAÇÃO',
        loading: 'carregando ....',
        slaughter: 'Abate: ',
        slaughterDate: 'Data de Abate: ',
        animalsQuantity: 'Qtde de animais: ',
        sendTo: 'Enviar Para',
        buyOrSell: 'Vendeu ou Comprou?',
        buy: 'Vendeu',
        sell: 'Comprou',
        negotiationDate: 'Data de Negociação ',
        tags: 'O que necociou?',
        slaughterForm: 'Forma de Abate',
        deliveryDate: 'Data da entrega',
        bovineAge: 'Idade do Bovino em Meses',
        breed: 'Raça',
        weight: 'Peso do Bovino (Kg)',
        bovineQuantity: 'Quantidade de Animais',
        paymentForm: 'Forma de Pagamento',
        tax: 'Imposto',
        freight: 'Frete por conta do',
        city: 'Cidade',
        bovineSlaughterQuantity: 'Quantidade de animais abatidos',
        labels: {
          selectTag: 'Selecione uma Tag',
          dead_weight: 'Peso Morto',
          live_weight: 'Peso Vivo',
          paymentForm: {
            in_cash: 'À vista',
            in_installment: 'À prazo'
          },
          taxForm: {
            to_charge: 'Pagamento sobre a folha 20%',
            free: 'À descontar 1,5% na comercialização',
            free_taxes: 'Livre de impostos'
          },
          freight: {
            buyer: 'Comprador - FOB',
            seller: 'Vendedor - CIF'
          }
        },
        placeholders: {
          fridge: 'Planta de Abate',
          value: 'Valor Negociado',
          paymentDeadline: 'Quantos dias de Prazo?',
          city: 'Cidade',
          observation: 'Observação'
        },
        options: {
          paymentMeasure: {
            fifteenKilos: 'R$/arroba',
            sacs: 'saca',
            tons: 'tonelada',
            head: 'Cabeças'
          },
          bovineAge: {
            zeroToTwelve: '0 a 12',
            twelveToEighteen: '12 a 18',
            eighteenToTwentyFour: '18 a 24',
            twentyFourToThirtySix: '24 a 36',
            aboveThirtySix: 'acima de 36',
          }
        },
        buttons: {
          addSlaughter: 'Adicionar Abate',
          send: 'ENVIAR'
        },
        messages: {
          success: 'DADOS ENVIADOS COM SUCESSO!',
          invalidData: 'DADOS INCORRETOS!'
        },
      }

    }
  }
}
